import React, { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import clsx from "clsx";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Reviews from "./components/Reviews";
import Bookings from "./components/Bookings";
import Menu from "./components/Menu";
import Payments from "./components/Payments/Payments";
import { getRestaurantByIdApi } from "./Api";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

const SingleRestaurant = (props) => {
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const restaurantId = props.match.params.id;
  const percentage = 66;
  const history = useHistory();

  const [restroData, setRestroData] = useState(null);

  useEffect(() => {
    getRestaurantData();
    return () => {};
  }, [1]);

  const getRestaurantData = async () => {
    const res = await getRestaurantByIdApi(restaurantId);

    if (res.error) {
      return console.log("Res is", res.data);
    } else {
      setRestroData(res.data.data);
      console.log(res.data.data);
    }
  };

  const editRedirect = () => {
    history.push({
      pathname: "/restaurant/edit/" + restaurantId,
      state: {
        data: restroData,
      },
    });
  };

  const SideBar = () => {
    return (
      <div>
        {/* Sidebar code div here  */}
        <div className="w-full py-2 px-10 bg-white min-h-screen">
          <div className="bg-indigo-900 p-4 mt-3 text-white">
            <div className="w-full flex justify-between items-center">
              <p className="font-semibold text-sm"> Payment Plan </p>
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.33325 9.99996C3.33325 9.53972 3.70635 9.16663 4.16659 9.16663H15.8333C16.2935 9.16663 16.6666 9.53972 16.6666 9.99996C16.6666 10.4602 16.2935 10.8333 15.8333 10.8333H4.16659C3.70635 10.8333 3.33325 10.4602 3.33325 9.99996Z"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.41058 3.57739C9.73602 3.25195 10.2637 3.25195 10.5891 3.57739L16.4224 9.41072C16.7479 9.73616 16.7479 10.2638 16.4224 10.5892L10.5891 16.4226C10.2637 16.748 9.73602 16.748 9.41058 16.4226C9.08514 16.0971 9.08514 15.5695 9.41058 15.2441L14.6547 9.99998L9.41058 4.7559C9.08514 4.43047 9.08514 3.90283 9.41058 3.57739Z"
                    fill="white"
                  />
                </svg>
              </span>
            </div>
            <p className="text-xs my-1 text-gray-100 font-light">
              {" "}
              1000 SGD per table booking <Skeleton width={100} />
            </p>
            <p className=" text-xs 0 text-gray-100">
              {" "}
              2000 SGD platform subscription <Skeleton width={100} />
            </p>
          </div>

          {restroData && (
            <div className="my-1 p-1 text-xs  ">
              <p className="font-medium  my-4 ">
                {" "}
                <span className="text-gray-500 font-light">Email : </span>{" "}
                {restroData && restroData.email}{" "}
              </p>
              <p className="font-medium  my-4 ">
                {" "}
                <span className="text-gray-500 font-light">Phone : </span>{" "}
                {restroData && restroData.phone}{" "}
              </p>
              <p className="font-medium  my-4 ">
                {" "}
                <span className="text-gray-500 font-light">Type: </span>{" "}
                {restroData && restroData.restaurantType}{" "}
              </p>
              <p className="font-medium  my-4 ">
                {" "}
                <span className="text-gray-500 font-light">
                  Website :{" "}
                </span>{" "}
                {restroData && restroData.website}{" "}
              </p>
              <p className="font-medium  my-4 ">
                {" "}
                <span className="text-gray-500 font-light">
                  Reg. ON :{" "}
                </span>{" "}
                {restroData && restroData.registeredNo}
              </p>
              <p className="font-medium  my-4 ">
                {" "}
                <span className="text-gray-500 font-light">
                  Location :{" "}
                </span>{" "}
                {restroData && restroData.address}{" "}
              </p>
              <p className="font-medium  my-4 ">
                {" "}
                <span className="text-gray-500 font-light">
                  Total Capacity :{" "}
                </span>{" "}
                {restroData && restroData.capacity}{" "}
              </p>
              <p className="font-medium  my-4 ">
                {" "}
                <span className="text-gray-500 font-light">
                  Table Count :{" "}
                </span>{" "}
                {restroData && restroData.totalTables}{" "}
              </p>
              <p className="font-medium  my-4 ">
                {" "}
                <span className="text-gray-500 font-light">
                  Acc Manager :{" "}
                </span>{" "}
                {restroData && restroData.accountManager}{" "}
              </p>
              <p className="font-medium  my-4 ">
                {" "}
                <span className="text-gray-500 font-light">
                  Cuisines :{" "}
                </span>{" "}
                {restroData && restroData.cuisines[0]}{" "}
              </p>
              <p className=" font-medium my-4 ">
                {" "}
                <span className="text-gray-500 font-light">
                  Halal Certified :{" "}
                </span>{" "}
                {restroData && restroData.isHalalCertified}
              </p>
              <p className="font-medium  my-4 ">
                {" "}
                <span className="text-gray-500 font-light">
                  Halal Certificate :{" "}
                </span>{" "}
                {restroData && restroData.halalCertificate}{" "}
              </p>
              <p className="font-medium  my-4 ">
                {" "}
                <span className="text-gray-500 font-light">
                  Avg Meal Cost :{" "}
                </span>{" "}
                {restroData && restroData.averageCost}{" "}
              </p>

              <button
                onClick={() => editRedirect()}
                className="border border-red-300 text-red-400 p-2 text-xs font-medium my-2"
              >
                {" "}
                Edit Details
              </button>
            </div>
          )}

          {!restroData && (
            <div className="my-1 p-1 text-xs  ">
              <p className="font-medium  my-4 ">
                Email : <Skeleton />
              </p>
              <p className="font-medium  my-4 ">
                Phone :<Skeleton />
              </p>
              <p className="font-medium  my-4 ">
                Website : <Skeleton />
              </p>
              <p className="font-medium  my-4 ">
                Location : <Skeleton />
              </p>
              <p className="font-medium  my-4 ">
                Owner : <Skeleton />
              </p>
              <p className="font-medium  my-4 ">
                Halal Certificate
                <Skeleton />
              </p>
              <p className="font-medium  my-4 ">
                Total Capacity
                <Skeleton />
              </p>
              <p className="font-medium  my-4 ">
                Table Count
                <Skeleton />
              </p>
              <p className="font-medium  my-4 ">
                <Skeleton />
              </p>
              <p className="font-medium  my-4 ">
                <Skeleton />
              </p>

              <button className="border p-2 text-xs font-medium my-2">
                <Skeleton width={100} />
              </button>
            </div>
          )}
        </div>
        {/* Sidebar code div here  */}
      </div>
    );
  };

  return (
    <div className="w-full bg-gray-100  min-h-screen">
      <div className="bg-white border border-b-2 border-gray-300 p-2 px-8">
        <p className="text-gray-600 text-xs font-normal">
          All Restaurants -{" "}
          {(restroData && restroData.restaurant_name) || (
            <Skeleton width={100} />
          )}{" "}
          - Summary
        </p>

        <div className="text-gray-700 text-md font-medium my-3 flex items-center mr-6">
          Showing :{" "}
          {(restroData && restroData.restaurant_name) || (
            <Skeleton width={200} />
          )}
          <span className="flex items-center ml-6 ">
            || &nbsp; Rated : {(restroData && restroData.current_rating) || 0}
            <svg
              width="16"
              height="16"
              viewBox="0 0 25 24"
              fill="none"
              className="-mt-1 ml-2"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.4166 0C12.826 0 13.2 0.243278 13.3812 0.627556L16.4553 7.14556L23.3297 8.19722C23.7348 8.25919 24.0712 8.55643 24.1974 8.96402C24.3237 9.37161 24.218 9.81888 23.9247 10.1178L18.9513 15.1878L20.125 22.3504C20.1942 22.7728 20.0283 23.1998 19.697 23.4517C19.3657 23.7036 18.9265 23.7368 18.564 23.5373L12.4166 20.1536L6.26913 23.5373C5.90669 23.7368 5.46747 23.7036 5.13616 23.4517C4.80485 23.1998 4.63893 22.7728 4.70815 22.3504L5.88189 15.1878L0.908449 10.1178C0.615178 9.81888 0.509461 9.37161 0.635731 8.96402C0.762 8.55643 1.09837 8.25919 1.50345 8.19722L8.37792 7.14556L11.452 0.627556C11.6332 0.243278 12.0071 0 12.4166 0Z"
                fill="#F4B13E"
              />
            </svg>
          </span>
        </div>

        <ul className="list-none flex items-center justify-between w-4/12   font-light">
          <li
            onClick={() => setActiveTabIndex(1)}
            className={clsx(
              "p-2 text-sm font-semibold text-gray-500 pl-0  rounded-sm px-3  cursor-pointer",
              { ["bg-white text-red-400 "]: activeTabIndex == 1 }
            )}
          >
            Summary
          </li>
          <li
            onClick={() => setActiveTabIndex(2)}
            className={clsx(
              "p-2 text-sm font-semibold text-gray-500 rounded-sm px-3 cursor-pointer",
              { ["bg-white text-red-400"]: activeTabIndex == 2 }
            )}
          >
            Bookings
          </li>
          <li
            onClick={() => setActiveTabIndex(3)}
            className={clsx(
              "p-2 text-sm font-semibold text-gray-500 rounded-sm px-3 cursor-pointer",
              { ["bg-white text-red-400"]: activeTabIndex == 3 }
            )}
          >
            Payments
          </li>
          <li
            onClick={() => setActiveTabIndex(4)}
            className={clsx(
              "p-2 text-sm font-semibold text-gray-500 rounded-sm px-3 cursor-pointer",
              { ["bg-white text-red-400"]: activeTabIndex == 4 }
            )}
          >
            Reviews
          </li>
          <li
            onClick={() => setActiveTabIndex(5)}
            className={clsx(
              "p-2 text-sm font-semibold text-gray-500 rounded-sm px-3 cursor-pointer",
              { ["bg-white text-red-400"]: activeTabIndex == 5 }
            )}
          >
            Menu
          </li>
        </ul>
      </div>

      {activeTabIndex == 1 && (
        <div className="w-full flex  min-h-screen ">
          <div className="w-3/12">
            <SideBar restaurantId={restaurantId} />
          </div>

          <div className="w-9/12 p-3 ">
            <div className="flex justify-between">
              <div className="flex-1 m-4 h-48 bg-white rounded-md p-4 py-2">
                <div className="font-semibold">
                  <div className="flex justify-between items-center">
                    <h2>Weekly Booking</h2>
                    <p className="text-xs font-medium text-indigo-500 m-3">
                      View
                    </p>
                  </div>

                  <div className="m-3 mx-auto h-28 w-28">
                    <CircularProgressbar
                      value={percentage}
                      text={`${percentage}%`}
                    />
                  </div>
                </div>
              </div>

              <div className="flex-1 m-4 h-48 bg-white rounded-md p-4 py-2">
                <div className="font-semibold">
                  <div className="flex justify-between items-center">
                    <h2>Pending Payments</h2>
                    <p className="text-xs font-medium text-indigo-500 m-3">
                      View
                    </p>
                  </div>

                  <div className="flex items-center my-2">
                    <p className="bg-green-300 w-12 text-center font-medium text-2xl ">
                      1
                    </p>
                    <p className="text-xs font-medium text-gray-500 m-3">
                      2000.00 SGD due for platform subscription fee Everything.
                    </p>
                  </div>
                  <div className="flex items-center my-2">
                    <p className="bg-red-300  text-center w-12 font-medium text-2xl ">
                      2
                    </p>
                    <p className="text-xs font-medium text-gray-500 m-3">
                      2000.00 SGD due for platform subscription fee Everything.
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex-1 m-4 h-48 bg-white rounded-md p-4 py-2">
                <div className="font-semibold">
                  <div className="flex justify-between items-center">
                    <h2>Customer Feedback</h2>
                    <p className="text-xs font-medium text-indigo-500 m-3">
                      View
                    </p>
                  </div>

                  <div className="flex">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.4166 0C12.826 0 13.2 0.243278 13.3812 0.627556L16.4553 7.14556L23.3297 8.19722C23.7348 8.25919 24.0712 8.55643 24.1974 8.96402C24.3237 9.37161 24.218 9.81888 23.9247 10.1178L18.9513 15.1878L20.125 22.3504C20.1942 22.7728 20.0283 23.1998 19.697 23.4517C19.3657 23.7036 18.9265 23.7368 18.564 23.5373L12.4166 20.1536L6.26913 23.5373C5.90669 23.7368 5.46747 23.7036 5.13616 23.4517C4.80485 23.1998 4.63893 22.7728 4.70815 22.3504L5.88189 15.1878L0.908449 10.1178C0.615178 9.81888 0.509461 9.37161 0.635731 8.96402C0.762 8.55643 1.09837 8.25919 1.50345 8.19722L8.37792 7.14556L11.452 0.627556C11.6332 0.243278 12.0071 0 12.4166 0Z"
                        fill="#F4B13E"
                      />
                    </svg>

                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.4166 0C12.826 0 13.2 0.243278 13.3812 0.627556L16.4553 7.14556L23.3297 8.19722C23.7348 8.25919 24.0712 8.55643 24.1974 8.96402C24.3237 9.37161 24.218 9.81888 23.9247 10.1178L18.9513 15.1878L20.125 22.3504C20.1942 22.7728 20.0283 23.1998 19.697 23.4517C19.3657 23.7036 18.9265 23.7368 18.564 23.5373L12.4166 20.1536L6.26913 23.5373C5.90669 23.7368 5.46747 23.7036 5.13616 23.4517C4.80485 23.1998 4.63893 22.7728 4.70815 22.3504L5.88189 15.1878L0.908449 10.1178C0.615178 9.81888 0.509461 9.37161 0.635731 8.96402C0.762 8.55643 1.09837 8.25919 1.50345 8.19722L8.37792 7.14556L11.452 0.627556C11.6332 0.243278 12.0071 0 12.4166 0Z"
                        fill="#F4B13E"
                      />
                    </svg>

                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.4166 0C12.826 0 13.2 0.243278 13.3812 0.627556L16.4553 7.14556L23.3297 8.19722C23.7348 8.25919 24.0712 8.55643 24.1974 8.96402C24.3237 9.37161 24.218 9.81888 23.9247 10.1178L18.9513 15.1878L20.125 22.3504C20.1942 22.7728 20.0283 23.1998 19.697 23.4517C19.3657 23.7036 18.9265 23.7368 18.564 23.5373L12.4166 20.1536L6.26913 23.5373C5.90669 23.7368 5.46747 23.7036 5.13616 23.4517C4.80485 23.1998 4.63893 22.7728 4.70815 22.3504L5.88189 15.1878L0.908449 10.1178C0.615178 9.81888 0.509461 9.37161 0.635731 8.96402C0.762 8.55643 1.09837 8.25919 1.50345 8.19722L8.37792 7.14556L11.452 0.627556C11.6332 0.243278 12.0071 0 12.4166 0Z"
                        fill="#F4B13E"
                      />
                    </svg>

                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.4166 0C12.826 0 13.2 0.243278 13.3812 0.627556L16.4553 7.14556L23.3297 8.19722C23.7348 8.25919 24.0712 8.55643 24.1974 8.96402C24.3237 9.37161 24.218 9.81888 23.9247 10.1178L18.9513 15.1878L20.125 22.3504C20.1942 22.7728 20.0283 23.1998 19.697 23.4517C19.3657 23.7036 18.9265 23.7368 18.564 23.5373L12.4166 20.1536L6.26913 23.5373C5.90669 23.7368 5.46747 23.7036 5.13616 23.4517C4.80485 23.1998 4.63893 22.7728 4.70815 22.3504L5.88189 15.1878L0.908449 10.1178C0.615178 9.81888 0.509461 9.37161 0.635731 8.96402C0.762 8.55643 1.09837 8.25919 1.50345 8.19722L8.37792 7.14556L11.452 0.627556C11.6332 0.243278 12.0071 0 12.4166 0Z"
                        fill="#F4B13E"
                      />
                    </svg>

                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.4166 0C12.826 0 13.2 0.243278 13.3812 0.627556L16.4553 7.14556L23.3297 8.19722C23.7348 8.25919 24.0712 8.55643 24.1974 8.96402C24.3237 9.37161 24.218 9.81888 23.9247 10.1178L18.9513 15.1878L20.125 22.3504C20.1942 22.7728 20.0283 23.1998 19.697 23.4517C19.3657 23.7036 18.9265 23.7368 18.564 23.5373L12.4166 20.1536L6.26913 23.5373C5.90669 23.7368 5.46747 23.7036 5.13616 23.4517C4.80485 23.1998 4.63893 22.7728 4.70815 22.3504L5.88189 15.1878L0.908449 10.1178C0.615178 9.81888 0.509461 9.37161 0.635731 8.96402C0.762 8.55643 1.09837 8.25919 1.50345 8.19722L8.37792 7.14556L11.452 0.627556C11.6332 0.243278 12.0071 0 12.4166 0Z"
                        fill="#F4B13E"
                      />
                    </svg>
                  </div>

                  <p className="text-xs font-medium text-gray-500 my-5">
                    2000.00 SGD due for platform subscription fee Everything
                    went well.
                  </p>
                  <p className="text-xs font-medium text-gray-500 my-5">
                    2000.00 SGD due for platform subscription fee Everything.
                  </p>
                </div>
              </div>
            </div>

            <Link to={`/restaurantfloors/${restaurantId}`}>
              <button className="bg-indigo-500 hover:bg-indigo-700 text-white px-5 mx-4 py-2">
                Floors & Tables
              </button>
            </Link>

            <div className="flex border bg-white border-gray-200 rounded-sm mt-8 mx-4">
              <div className="p-2 flex items-center flex-wrap">
                {restroData &&
                  restroData.restaurant_images.map((image, i) => {
                    return (
                      <img
                        className="m-2 h-20vh object-cover"
                        src={image}
                        key={i}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTabIndex == 2 && <Bookings restaurantId={restaurantId} />}

      {activeTabIndex == 3 && <Payments />}

      {activeTabIndex == 4 && <Reviews restaurantId={restaurantId} />}

      {activeTabIndex == 5 && restroData && <Menu restroData={restroData} />}
    </div>
  );
};

export default SingleRestaurant;
